import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import {  
  ApexChart, 
  ApexFill, 
  ApexLegend, 
  ApexNonAxisChartSeries, 
  ApexPlotOptions, 
  ApexResponsive, 
  ChartComponent} from 'ng-apexcharts';


export type PieChartOptionsInfoTile = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  responsive: ApexResponsive[];
  colors: any;
  labels: any;
  dataLabels: any;
  legend: ApexLegend;
  sparkline: any;

 };

@Component({
  standalone: false,
  selector: 'app-info-tile',
  templateUrl: './info-tile.component.html',
  styleUrls: ['./info-tile.component.scss'],
})



export class InfoTileComponent implements OnInit, OnChanges {
    @ViewChild("chart") chart: ChartComponent;
    @Input() headerText: string;
    @Input() numberPiS: number;
    @Input() inProgress: number;
    @Input() submitted: number;
    @Input() notStarted: number;
    @Input() counted: number;
    @Input() consolidated: boolean;
    @Input() plannedCountDate: string;
    @Input() type: string;
    @Input() piNumber:string;
    @Input() status:string;
    @Input() colour:string;
    @Input() isLoading: boolean;
    public pieChartOptions: Partial<PieChartOptionsInfoTile>;
    calcInProgress:number = 0;
    calcSubmitted:number = 0;
    calcNotStarted:number = 0;
    calcCounted:number = 0;

  constructor() {    
  }
  ngOnChanges(changes: SimpleChanges): void {
    this.calcInProgress =  Math.round((this.inProgress/this.numberPiS)*100);
    var inProgressLabel = `${this.calcInProgress}% In Progress`;

    this.calcSubmitted =  Math.round((this.submitted/this.numberPiS)*100);
    var submittedLabel = `${this.calcSubmitted}% Submitted`;

    this.calcNotStarted =  Math.round((this.notStarted/this.numberPiS)*100);
    var notStartedLabel = `${this.calcNotStarted}% Not Started`;

    this.calcCounted =  Math.round((this.counted/this.numberPiS)*100);
    var countedLabel = `${this.calcCounted}% Counted`;

    if(!isNaN(this.calcNotStarted) && !isNaN(this.calcInProgress) && !isNaN(this.calcSubmitted) && !isNaN(this.calcCounted))
      {
        this.pieChartOptions = this.buildBasicPieChartWithoutLabels(170,[this.calcNotStarted, this.calcInProgress,this.calcSubmitted, this.calcCounted],[notStartedLabel, inProgressLabel,submittedLabel,countedLabel]);
    
      }
      else{
        this.pieChartOptions = this.buildBasicPieChartWithoutLabels(170,[0,0,0,0],[notStartedLabel, inProgressLabel,submittedLabel,countedLabel]);
      }
      
    this.isLoading = false;
  }

  ngOnInit(): void {
    
  }

  buildBasicPieChartWithoutLabels(width: number, values: number[], labels: string[]): PieChartOptionsInfoTile {
    return {
      series: values,
      chart: {
        width: width,
        type: 'donut',
      },
      legend: {
        show: false,
        position: 'left'
      },
      dataLabels: {
       enabled: false,
       formatter: function (val: number) {
         return val
       },
     },
     sparkline: {
      enabled: true
     },
      labels: labels,
      colors: ['#9B9B9B', '#E2AE13', '#5DB353', '#1393D2'],
      responsive: [
          {
            breakpoint: 480,
            options: {
              chart: {
                width: width,
              },
            
            },
          },
        ],
        
      };
  }


  

 
}
